import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import App from './App';
import './index.css';
import { BrowserRouter } from "react-router-dom";
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { store } from './redux/store';
import { setupAxiosAuthInterceptor } from './mixins/authSession';
import dayjs from "dayjs";
import utc from 'dayjs/plugin/utc'; dayjs.extend(utc);
import timezone from 'dayjs/plugin/timezone'; dayjs.extend(timezone);

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: true,
            retry: 1,
        },
    },
});
setupAxiosAuthInterceptor(store);

ReactDOM.render(
    <Provider store={store}>
        <QueryClientProvider client={queryClient}>
            <BrowserRouter>
                <App/>
            </BrowserRouter>
        </QueryClientProvider>
    </Provider>,
    document.getElementById('root')
);
